import { useState } from "react";
import { ChevronDown, ChevronRight, Brain } from "lucide-react";
import { cn } from "@/lib/utils";

interface ReasoningBlockProps {
  content: string;
  defaultOpen?: boolean;
}

export const ReasoningBlock = ({ content, defaultOpen = false }: ReasoningBlockProps) => {
  const [open, setOpen] = useState(defaultOpen);
  if (!content) return null;
  return (
    <div className="mb-2 rounded-lg border border-border/40 bg-muted/20">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-2 px-3 py-2 text-xs text-muted-foreground hover:text-foreground"
      >
        {open ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        <Brain className="h-3 w-3" />
        <span className="font-medium">Thinking</span>
      </button>
      {open && (
        <div className={cn("px-3 pb-2 text-xs text-muted-foreground/80 whitespace-pre-wrap font-mono")}>
          {content}
        </div>
      )}
    </div>
  );
};
